import { hashMessage } from './hashMessage.js';
import { recoverAddress } from './recoverAddress.js';
export async function recoverMessageAddress(_ref) {
  let {
    message,
    signature
  } = _ref;
  return recoverAddress({
    hash: hashMessage(message),
    signature
  });
}
//# sourceMappingURL=recoverMessageAddress.js.map